import { IconProps } from './types';

export default function IconOutlink({ width = '16', height = '16', fill = '#06487C', className }: IconProps) {
    return (
        <svg width={width} height={height} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
            <g clip-path='url(#clip0_1566_1051)'>
                <g filter='url(#filter0_g_1566_1051)'>
                    <path d='M7.46875 4.94531C7.46875 4.57856 7.17146 4.28125 6.80469 4.28125H3.75C3.16318 4.28125 2.6875 4.75695 2.6875 5.34375V12.25C2.6875 12.8368 3.16318 13.3125 3.75 13.3125H10.6562C11.2431 13.3125 11.7188 12.8368 11.7188 12.25V9.19531C11.7188 8.82854 11.4215 8.53125 11.0547 8.53125C10.6879 8.53125 10.3906 8.82854 10.3906 9.19531V11.9844H4.01562V5.60938H6.80469C7.17146 5.60938 7.46875 5.31207 7.46875 4.94531Z' fill={fill} />
                    <path fill-rule='evenodd' clip-rule='evenodd' d='M11.0452 4.01562H9.72651C9.35973 4.01562 9.06245 3.71832 9.06245 3.35156C9.06245 2.98481 9.35973 2.6875 9.72651 2.6875H12.6484C13.0151 2.6875 13.3124 2.98481 13.3124 3.35156V6.27344C13.3124 6.64019 13.0151 6.9375 12.6484 6.9375C12.2816 6.9375 11.9843 6.64019 11.9843 6.27344V4.95475L7.34534 9.59375C7.08598 9.85311 6.66557 9.85311 6.40622 9.59375C6.14686 9.33439 6.14686 8.91396 6.40622 8.65461L11.0452 4.01562Z' fill={fill} />
                </g>
            </g>
            <defs>
                <filter id='filter0_g_1566_1051' x='-0.375' y='-0.375' width='16.75' height='16.75' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
                    <feTurbulence type='fractalNoise' baseFrequency='0.02083333395421505 0.02083333395421505' numOctaves='3' seed='6155' />
                    <feDisplacementMap in='shape' scale='4' xChannelSelector='R' yChannelSelector='G' result='displacedImage' width='100%' height='100%' />
                    <feMerge result='effect1_texture_1566_1051'>
                        <feMergeNode in='displacedImage' />
                    </feMerge>
                </filter>
                <clipPath id='clip0_1566_1051'>
                    <rect width='16' height='16' fill='white' />
                </clipPath>
            </defs>
        </svg>


    )
}